import { Button, Flex, Group } from '@mantine/core'
import AppIcon from './AppIcon'
import { themeCfg } from '../../theme/theme.ts'

interface CustomProps extends React.ComponentPropsWithoutRef<typeof Button> {
  icon?: string
  iconPosition?: 'left' | 'right'
  label?: string
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  variant?: 'default' | 'outline' | 'subtle' | 'solid'
  color?: string
  bg?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const AppLegacyButton = ({
  icon,
  iconPosition = 'right',
  label,
  onClick,
  disabled = false,
  loading = false,
  variant = 'default',
  color = 'moure-orange',
  size = 'md',
  ...otherProps
}: CustomProps &
  React.ComponentPropsWithoutRef<typeof Button> & {
    label: string
    onClick?: () => void
    disabled?: boolean
    loading?: boolean
    variant?: string
    color?: string
    size?: string
  }) => {
  return (
    <>
      <Button
        visibleFrom={themeCfg?.breakpoint}
        p="xs"
        h={36} /* Default PrimeReact height */
        fz={14}
        variant={variant}
        leftSection={iconPosition === 'left' ? <AppIcon icon={icon} /> : label}
        rightSection={
          iconPosition === 'right' ? <AppIcon icon={icon} /> : label
        }
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        c={color}
        size={size}
        {...otherProps}
      />
      <Button
        hiddenFrom={themeCfg?.breakpoint}
        p="xs"
        h={36} /* Default PrimeReact height */
        fz={14}
        variant={variant}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        c={color}
        size={size}
        {...otherProps}
      >
        <Group hiddenFrom={themeCfg?.breakpoint}>
          <AppIcon icon={icon} />
        </Group>
      </Button>
    </>
  )
}

export default AppLegacyButton
